import { of, from } from 'rxjs';
import { map, first, catchError } from 'rxjs/operators';
import axios from 'axios';

const config = { headers: { 'Content-Type': 'application/json' } };
const DEFAULT_FAILURE_MESSAGE = { response: 'failure', message: '' }; // default failure message.
const SJF_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_SYNDICATED_JOB_FEED_SECURE }`;
const UPWARD_SEARCH_URL = `${ process.env.REACT_APP_FULL_DOMAIN_LF_UPWARD_NET }/search/`;

const evaluateFromBooleanOnOff = (bool) => {
   if (typeof bool === 'boolean') {
      return bool ? 'ON' : 'OFF';
   }

   return 'OFF';
};

const evaluateFromBooleanYN = (bool) => {
   if (typeof bool === 'boolean') {
      return bool ? 'Y' : 'N';
   }

   return 'N';
};

const getSearchQueryString = (requestBody, isExport) => {
   const { organization, hiringCompany, company, contract, radius, device, category, keyword, source,
      showByDistanceMultiplier, showByAgeMultiplier, fallBackSearch, sortByCpc, showByHiringCompany, showByJobGroup,
      showByJobDescription, showByMoreDetails, useCpcRules, location, totalPages, disableTrafficRules } = requestBody;
   const queryArray = [];
   queryArray.push(`export=${ evaluateFromBooleanYN(isExport) }`);
   queryArray.push(`TRAFFIC_RULE_DEBUG_MODE=${ disableTrafficRules ? 'MODE_FORCE' : '' }`);
   queryArray.push(`org_text=${ organization ? organization.name : '' }`);
   queryArray.push(`dboost=${ evaluateFromBooleanOnOff(showByDistanceMultiplier) }`);
   queryArray.push(`advertiser_text=${ hiringCompany ? hiringCompany.name : '' }`);
   queryArray.push(`timeboost=${ evaluateFromBooleanOnOff(showByAgeMultiplier) }`);
   queryArray.push('job_group_text=');
   queryArray.push(`e=${ evaluateFromBooleanYN(fallBackSearch) }`);
   queryArray.push(`keyword=${ keyword || '' }`);
   queryArray.push(`sort_by_cpc=${ evaluateFromBooleanOnOff(sortByCpc) }`);
   queryArray.push(`location=${ location || '' }`);
   queryArray.push(`show_hc=${ evaluateFromBooleanOnOff(showByHiringCompany) }`);
   queryArray.push(`c=${ company ? company.name : '' }`);
   queryArray.push(`show_jg=${ evaluateFromBooleanOnOff(showByJobGroup) }`);
   queryArray.push(`cat=${ category || '' }`);
   queryArray.push(`show_jd=${ evaluateFromBooleanOnOff(showByJobDescription) }`);
   queryArray.push(`radius=${ radius ? radius.id : '' }`);
   queryArray.push(`show_tx=${ evaluateFromBooleanOnOff(showByMoreDetails) }`);
   queryArray.push('page_size=25');
   queryArray.push(`TRAFFIC_RULE_DEBUG_IDS=${ disableTrafficRules ? '0' : '' }`);
   queryArray.push(`CID=${ contract ? contract.id : '' }`);
   queryArray.push('exclude_organizations=N');
   queryArray.push(`device=${ device ? device.name : '' }`);
   queryArray.push(`OID=${ source ? source.offerId : '' }`);
   queryArray.push(`useCpc=${ evaluateFromBooleanOnOff(useCpcRules) }`);
   queryArray.push(`organization_id=${ organization ? organization.id : '' }`);
   queryArray.push(`advertiser_id=${ hiringCompany ? hiringCompany.id : '' }`);
   queryArray.push('campaign_id=');
   queryArray.push('format=json');

   // API signature requested by the API developer
   if (totalPages !== undefined) {
      queryArray.push(`pages=${ totalPages }`);
   }

   return queryArray.join('&');
};

export const jobSearchEmulate = (data) => {
   // reshaped data because server-side api is already built with the name field
   const {
      showAgeMultiplier: showByAgeMultiplier,
      showDistanceMultiplier: showByDistanceMultiplier,
      showHiringCompany: showByHiringCompany,
      showJobDescription: showByJobDescription,
      showJobGroup: showByJobGroup,
      showMoreDetails: showByMoreDetails,
      ...restData
   } = data;

   return from(
      axios.get(
         `${ UPWARD_SEARCH_URL }solrJobList.fsn?${ getSearchQueryString({
            showByAgeMultiplier,
            showByDistanceMultiplier,
            showByHiringCompany,
            showByJobDescription,
            showByJobGroup,
            showByMoreDetails,
            ...restData,
         }, false) }`,
         config,
      ),
   ).pipe(
      first(),
      map((res) => (res && res.data ? { data: res.data } : {})),
      catchError((err) => {
         console.log(err);
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Please try again' });
      }),
   );
};

export const exportJobSearchEmulate = (data) => {
   return axios.get(
      `${ UPWARD_SEARCH_URL }solrJobList.fsn?${ getSearchQueryString(data, true) }`,
      config,
   ).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'raw_data_expected_rev.csv');
      document.body.appendChild(link);
      link.click();
   });
};

export const debugTrafficRules = (data) => {
   return from(
      axios.get(
         `${ UPWARD_SEARCH_URL }trafficRuleDebugger.fsn?${ data }`,
      ),
   ).pipe(
      first(),
      map((res) => (res)),
      catchError((err) => {
         console.log(err);
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Please try again' });
      }),
   );
};

export const getDistinctSourceNames = () => {
   return (
      axios.get(
         `${ SJF_SECURE_BASE_URL }offer-source/get-distinct-source-names`,
      ).then((res) => {
         const data = !(res.data && res.data.length > 0)
            ? []
            : res.data.map((item) => {
               return ({
                  ...item,
                  label: item?.source,
                  value: item?.offerId,
               });
            });
         return ({
            data,
         });
      })
   );
};
